var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 21.54H7C3.83 21.54 1.25 18.96 1.25 15.79V6.20998C1.25 4.90998 1.85 4.45998 2.21 4.30998C2.57 4.15998 3.31 4.04998 4.23 4.96998L6.82 7.55998C6.92 7.65998 7.08 7.65998 7.17 7.55998L10.76 3.96998C11.42 3.30998 12.58 3.30998 13.23 3.96998L16.82 7.55998C16.92 7.65998 17.08 7.65998 17.17 7.55998L19.76 4.96998C20.68 4.04998 21.42 4.16998 21.78 4.30998C22.14 4.45998 22.74 4.89998 22.74 6.20998V15.8C22.75 19.23 20.44 21.54 17 21.54ZM2.81 5.73998C2.78 5.81998 2.75 5.96998 2.75 6.20998V15.8C2.75 18.14 4.66 20.05 7 20.05H17C19.58 20.05 21.25 18.38 21.25 15.8V6.20998C21.25 5.96998 21.22 5.82998 21.19 5.74998C21.11 5.78998 20.99 5.86998 20.82 6.03998L18.23 8.62998C17.57 9.28998 16.41 9.28998 15.76 8.62998L12.17 5.03998C12.07 4.93998 11.91 4.93998 11.82 5.03998L8.24 8.61998C7.58 9.27998 6.42 9.27998 5.77 8.61998L3.18 6.02998C3.01 5.85998 2.88 5.77998 2.81 5.73998Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.81514a3edcd289ef81912099945b2ec1.svg";
export { ForwardRef as ReactComponent };